import type { ThemeToggleTranslations } from "./pl";

export const de: ThemeToggleTranslations = {
  themeName: {
    light: "hell",
    dark: "dunkel",
    funeral: "trauer",
    hc: "hoher Kontrast",
  },
  tooltip: (name) => `Thema: ${name} (zum Wechseln klicken)`,
  ariaLabel: (name) => `Thema ändern, aktuell: ${name}`,
};
